<script lang="ts">
    import { onMount, setContext } from "svelte";

    const { children } = $props<{}>();

    const location = $state({
        path: window.location.pathname
    });

    setContext('location', location);

    onMount(() => {
        const updatePath = () => {
            location.path = window.location.pathname;
        }

        window.addEventListener('popstate', updatePath);
        window.addEventListener('pushstate', updatePath); 

        return () => {
            window.removeEventListener("popstate", updatePath);
            window.removeEventListener("pushstate", updatePath);
        };
    });
</script>

{@render children?.()}